(() => {
  const WHOLESALE_CONTAINER = '.nm-easywholesale-container';
  const PROGRAM_SELECT = `${WHOLESALE_CONTAINER} select[name="properties[Program]"]`;
  const ATC_BUTTON = `${WHOLESALE_CONTAINER} .nm-wholesale-btn-add-to-cart`;

  function getProgramSelect() {
    return document.querySelector(PROGRAM_SELECT);
  }

  function isProgramSelected() {
    const el = getProgramSelect();
    if (!el) return true; // если селект не найден — ничего не ломаем
    return (el.value || '').trim().length > 0;
  }

  function showProgramError() {
    const el = getProgramSelect();
    if (!el) {
      alert('Please select a Program before adding to cart.');
      return;
    }

    el.setAttribute('aria-invalid', 'true');
    el.style.outline = '2px solid #d20000';
    el.style.outlineOffset = '2px';

    let msg = document.querySelector('#nm-program-required-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.id = 'nm-program-required-msg';
      msg.style.color = '#d20000';
      msg.style.fontSize = '12px';
      msg.style.margin = '6px 0 10px';
      msg.textContent = 'Please select a Program.';
      el.insertAdjacentElement('afterend', msg);
    }

    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.focus({ preventScroll: true });
  }

  function clearProgramError() {
    const el = getProgramSelect();
    if (!el) return;
    el.removeAttribute('aria-invalid');
    el.style.outline = '';
    el.style.outlineOffset = '';
    const msg = document.querySelector('#nm-program-required-msg');
    if (msg) msg.remove();
  }

  // Перехват клика по кнопке EasyWholesale
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest(ATC_BUTTON);
      if (!btn) return;

      if (isProgramSelected()) return;

      // Блокируем выполнение обработчиков EasyWholesale
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();

      showProgramError();
    },
    true // capture, чтобы сработать раньше обработчиков приложения
  );

  // Убираем ошибку при выборе Program
  document.addEventListener('change', (e) => {
    if (e.target && e.target.matches(PROGRAM_SELECT)) {
      if (isProgramSelected()) clearProgramError();
    }
  });
})();